module.exports = __webpack_public_path__ + "img/207-Brun Noir.jpg";